import React from 'react';
import {
  Container, Option, OptionIcon, OptionContainer,
} from './styled';

function OptionsPicker({
  values,
  options = [],
  value,
  style = {},
  update = () => { },
  icons,
  ...other
}) {
  values = values || options;
  let _options = options;

  if (!values.find && typeof (values) === 'object') {
    values = Object.values(values);
    _options = Object.keys(options);
  }
  value = value || values.find((exist) => typeof (exist) !== undefined);

  //2 -> 16
  //4 -> 10
  const fontSize = `${parseInt(-3 * _options.length + 22)}px`;
  return (
    <Container {...other} style={{ ...style }}>
      {_options.map((option, index) => {
        if (typeof option === 'undefined') {
          return null;
        };
        const data_attr = `options-picker-${option
          .toLowerCase()
          .replace(/\s/, '_')}`;
        return (
          <OptionContainer
            data-cy={data_attr}
            fontSize={fontSize}
            onClick={() => update(values[index])}
            active={value === values[index]}
            key={index}>
            {icons && <OptionIcon src={icons[index]} />}
            <Option>
              {option}
            </Option>
          </OptionContainer>
        );
      })}
    </Container>
  );
}

export default OptionsPicker;
